export default function PHP_xor() {
  return (
    <div>
      <h1>PHP_xor</h1>
    </div>
  );
}
